<li class="px-xl">
  <ng-container [ngSwitch]="role">
    <ng-container *ngSwitchCase="'button'">
      <ng-container *ngTemplateOutlet="buttonMenuTpl" />
    </ng-container>

    <ng-container *ngSwitchDefault>
      <a
        *ngIf="!isExternalLink; else externalLinkTpl"
        class="menu-list-item__btn"
        [title]="title"
        [attr.data-testid]="'qa-menu-item-' + menuId"
        [routerLink]="routePath"
      >
        <ng-container *ngTemplateOutlet="linkContent" />
      </a>
    </ng-container>
  </ng-container>
</li>

<!-- START button menu template -->
<ng-template #buttonMenuTpl>
  <button
    class="menu-list-item__btn"
    type="button"
    [title]="title"
    [attr.data-testid]="'qa-menu-item-' + menuId"
    (click)="onClick.emit($event)"
  >
    <ng-container *ngTemplateOutlet="linkContent" />
  </button>
</ng-template>
<!-- END button menu template -->

<!-- START external link template -->
<ng-template #externalLinkTpl>
  <a
    class="menu-list-item__btn"
    target="_blank"
    [title]="title"
    [attr.data-testid]="'qa-menu-item-' + menuId"
    [href]="routePath"
    (click)="onClick.emit($event)"
  >
    <ng-container *ngTemplateOutlet="linkContent" />
  </a>
</ng-template>
<!-- END external link template -->

<!-- START link content -->
<ng-template #linkContent>
  <div class="menu-list-item__nav-left">
    <i class="nav__icon" [class]="menuIcon"></i>
    <span class="nav__text">{{ menuText }}</span>
  </div>

  <div class="menu-list-item__nav-right">
    <ng-content select="[nav-right]"></ng-content>

    <i *ngIf="!showLinkIcon; else linkIcon" class="nav__icon" [class]="iconService.regular.chevronRight"></i>
  </div>
</ng-template>

<ng-template #linkIcon>
  <i class="nav__icon" [class]="iconService.regular.arrowUpRightFromSquare"></i>
</ng-template>
<!-- END link content -->
